import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { UiIconsList } from '../model/ui-icons.model';

@Injectable({
  providedIn: 'root'
})
export class UiIconsService {
  private cachedIcons = new Map<UiIconsList, string>();

  constructor(private http: HttpClient) {}

  getIconContent(iconKey: UiIconsList) {
    if (this.cachedIcons.has(iconKey)) {
      return of(this.cachedIcons.get(iconKey));
    }

    return this.http.get(`assets/ui-icons/sh-icon-${iconKey}.svg`, { responseType: 'text' }).pipe(
      catchError(() => {
        console.error(`Icon ${iconKey} failed to be loaded`);
        return of('');
      }),
      tap(iconContent => this.cachedIcons.set(iconKey, iconContent))
    );
  }
}
